module.exports = __webpack_public_path__ + "static/flex_desk_2-2cdc7a2e394e399c45b7c0efa592c8f0.webp";